module.exports = (s) => {
  return [
    {
      name: '广告主账户',
      value: 'advertiser_id',
    },
    {
      name: '广告名称',
      value: 'campaign_name',
    },
    {
      name: '落地页',
      width: '220px',
      format: (row) => {
        const h = s.$createElement;
        const { sites } = row;

        const ele = h(
          'el-select',
          {
            props: {
              size: 'mini',
              value: sites.value,
              placeholder: '请选择',
              multiple: true,
              multipleLimit: s.multipleLimit,
              collapseTags: true,
              valueKey: 'id',
            },
            on: {
              change: (value) => {
                sites.value = value;
              },
            },
          },
          sites.options.map(site => {
            return h('el-option', { props: { label: site.name, value: site }}, null);
          }),
        );

        return sites.options.length ? ele : '-';
      },
    },
  ];
};
